import { createSelector } from 'reselect';
const getProductRecentlyViewed = (state) => state.productRecentlyViewed;
export const maketGetProductRecentlyViewedState = () => createSelector(getProductRecentlyViewed, products => products);
